import { rankingItems } from '@/mocks/homeData';

export default function Ranking() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10 md:mb-14">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">热搜榜单</h2>
            <p className="text-sm text-foreground-600">实时热搜排行，看看大家都在关注什么</p>
          </div>
          <span className="hidden sm:inline-flex items-center gap-1.5 text-xs text-foreground-500">
            <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
            实时更新中
          </span>
        </div>

        <div className="max-w-[800px] mx-auto">
          <div className="space-y-2">
            {rankingItems.map((item, i) => (
              <div
                key={i}
                className="flex items-center gap-3 md:gap-4 p-3 md:p-4 bg-background-50 border border-background-200/70 rounded-lg hover:border-primary-200 transition-all duration-200 cursor-pointer group"
              >
                <div className={`w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg shrink-0 font-heading text-sm md:text-base font-bold ${
                  item.rank === 1
                    ? 'bg-primary-500 text-background-50'
                    : item.rank === 2
                    ? 'bg-accent-500 text-background-50'
                    : item.rank === 3
                    ? 'bg-secondary-500 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <p className="text-sm md:text-base text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-1">
                    {item.title}
                  </p>
                </div>

                <div className="flex items-center gap-2 md:gap-3 shrink-0">
                  <span className="text-xs text-foreground-500 whitespace-nowrap">{item.heat} 热度</span>
                  {item.change === 'new' ? (
                    <span className="inline-flex items-center px-1.5 py-0.5 rounded-full bg-primary-100 text-primary-700 text-[10px] font-semibold whitespace-nowrap">
                      NEW
                    </span>
                  ) : (
                    <i className={`text-sm ${
                      item.change === 'up'
                        ? 'ri-arrow-up-line text-primary-500'
                        : 'ri-arrow-down-line text-foreground-400'
                    }`}></i>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}